import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Loader from 'oxyrion-ui/lib/Loader';
import { rem } from 'polished';
import { __ } from '../../../../Utils';
import { LoaderWrapper } from '../../../../Components/ReusableComponents';
import FileViewDownload from '../../../../Components/FileViewDownload';

const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const FileRow = styled.div`
  display: flex;
  height: ${props => (props.isTable ? 'auto' : rem(16))};
  align-items: center;
  background: #f0f0f0;
  padding: ${rem(8)};
  border-top: solid ${rem(1)} #dedede;
`;

const NoDocumentation = styled.div`
  font-size: 13px;
  margin-left: 6px;
  color: #434245;
`;

class CatalogProductDocumentation extends React.Component {
  downloadPDF(file) {
    this.props.downloadFile(file._id);
  }

  render() {
    const { files, loading } = this.props;

    return (
      <MainWrapper>
        {loading && (
          <LoaderWrapper>
            <Loader color="#70af00" />
          </LoaderWrapper>
        )}
        {files.length > 0 || loading ? (
          files.map(f => {
            return (
              <FileRow>
                <FileViewDownload
                  name={f.name}
                  fullPath={f.fullPath}
                  type={f.mimeType}
                  history={this.props.history}
                  downloadFunction={async () => {
                    return this.props.downloadFile(f._id);
                  }}
                  error={error => {
                    this.setState({ error });
                    this.props.onError(error)
                  }}
                />
              </FileRow>
            );
          })
        ) : (
          <NoDocumentation>{__('Bez dokumentácie')}</NoDocumentation>
        )}
      </MainWrapper>
    );
  }
}

CatalogProductDocumentation.propTypes = {
  loading: PropTypes.bool,
  downloadFile: PropTypes.func,
  onError: PropTypes.func,
  files: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      file: PropTypes.shape({
        fullPath: PropTypes.string,
        mimeType: PropTypes.string,
        name: PropTypes.string,
      }),
    }),
  ),
};

CatalogProductDocumentation.defaultProps = {
  files: [],
  downloadFile: () => {},
  onError: () => {},
  loading: false,
};

export default CatalogProductDocumentation;



// WEBPACK FOOTER //
// ./src/Containers/ProductCatalog/Components/Documentation/index.jsx